mutation MovementReportRequest($input: MovementReportRequestInput!) {
  movementReportRequest(input: $input) {
    _isRequestValid
    clientMutationId
  }
}
